import { useEffect, useState } from "react";

/** Breakpoint phân tách mobile / desktop — khớp với điểm Primer dùng (`<768px` = sm). */
const MOBILE_QUERY = "(max-width: 767px)";

/**
 * Trả `true` khi viewport ở kích thước mobile. Lắng nghe resize/đổi orientation để
 * ClassesPage tự chuyển nhánh render desktop ↔ mobile mà không cần reload.
 */
export const useIsMobile = (): boolean => {
    const [isMobile, setIsMobile] = useState<boolean>(
        () => typeof window !== "undefined" && window.matchMedia(MOBILE_QUERY).matches
    );

    useEffect(() => {
        const mql = window.matchMedia(MOBILE_QUERY);
        const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
        mql.addEventListener("change", onChange);
        // Sync lần đầu phòng khi state khởi tạo trước khi mql sẵn sàng.
        setIsMobile(mql.matches);
        return () => mql.removeEventListener("change", onChange);
    }, []);

    return isMobile;
};
